import React from 'react';

export default function Loader() {
  const loadingBlocks = [1, 2, 3];

  return (
    <div className="loading-container">
      <div className="loading loading--rotate">
        {loadingBlocks.map((loadingBlock) => (
          <div key={loadingBlock} className="loading__rotate-container">
            <div className="loading__ball"></div>
            <div className="loading__ball"></div>
            <div className="loading__ball"></div>
            <div className="loading__ball"></div>
          </div>
        ))}
      </div>
    </div>
  );
}
